import { createActionGroup, props } from '@ngrx/store';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const NotesResolverActions = createActionGroup({
  source: 'Notes resolver',
  events: {
    'Notes requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const NotesApiActions = createActionGroup({
  source: 'Notes API',
  events: {
    'Notes loaded': props<{ notes: Note[]; udid: string }>(),
    'Notes loaded error': props<{ error: ErrorModel }>(),
    'Note added': props<{ note: Note; udid: string }>(),
    'Note added error': props<{ error: ErrorModel }>(),
    'Note deleted': props<{ note: Note; udid: string }>(),
    'Note deleted error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const NotesUIActions = createActionGroup({
  source: 'Notes UI',
  events: {
    'Note added': props<{ note: Note; udid: string }>(),
    'Note deleted': props<{ note: Note; udid: string }>(),
  },
});
